<ng-container *ngIf="form">
  <form [formGroup]="form">
    <mat-form-field appearance="fill" floatLabel="always">
      <mat-label>Name</mat-label>
      <input matInput placeholder="" [formControlName]="'name'" />
    </mat-form-field>

    <mat-form-field appearance="fill" floatLabel="always">
      <mat-label>Description</mat-label>
      <input matInput placeholder="" [formControlName]="'description'" />
    </mat-form-field>

    <mat-divider></mat-divider>
    <table>
      <tr>
        <td>
          <mat-form-field appearance="fill" floatLabel="always" class="email-form-field">
            <mat-label>Email</mat-label>
            <input matInput placeholder="" [formControl]="currentEmailForm" />
          </mat-form-field>
        </td>
        <td class="button-holder">
          <button mat-stroked-button class="add-button" (click)="addEmailToList()">Add</button>
        </td>
      </tr>
    </table>

    <h3>Emails</h3>
    <div class="emails-container">
      <ng-container formArrayName="emailAddresses">
        <div
          *ngFor="let email of getEmailsAsFormArray().controls; let i = index"
          class="email-item"
        >
          <div class="email">
            {{ email.value }}
          </div>
          <button mat-flat-button (click)="remove(i)">remove</button>
        </div>
      </ng-container>
    </div>
  </form>
</ng-container>
<app-inlinemessage *ngIf="errorMessage" level="error" [message]="errorMessage"></app-inlinemessage>
<span class="required">* Required Field</span>
<div class="buttons" mat-dialog-actions>
  <button
    *ngIf="!data"
    mat-raised-button
    [disabled]="!canSave"
    class="donebutton"
    color="primary"
    (click)="save()"
  >
    OK
  </button>
  <button mat-button (click)="close()">{{ data ? 'Close' : 'Cancel' }}</button>
</div>
